import { j as d } from "../../../jsx-runtime-BwWtxLpl.js";
import { useContext as x, useEffect as h } from "react";
import i from "prop-types";
import w from "classnames";
import "../form-field/form-field.js";
import { FormFieldContext as I } from "../form-field/form-field.context.js";
const y = (o) => {
  const { children: l, className: r = "", ...a } = o, { isFocused: m, invalid: s, disabled: n, formElementType: t, required: f, id: p, iconPrefix: c, hasContent: u, hasLabel: E, setHasLabel: e } = x(I);
  h(() => {
    e(!0);
  }, [e]);
  const b = w({
    "motif-label": !0,
    "motif-focus": m,
    "motif-invalid": s,
    "motif-disabled": n,
    "motif-label-for-text": t === "textInput",
    "motif-label-for-text-area": t === "textAreaInput",
    "motif-label-for-slider": t === "slider",
    "motif-label-for-numeric-input": t === "numeric",
    "motif-label-required": f,
    "motif-label-with-icon-prefix": t === "textInput" && c,
    "motif-label-with-content": u,
    "motif-label-with-time-input": t === "timeInput",
    "motif-label-with-pin-entry": t === "pinEntry",
    "motif-label-with-date-picker": t === "dateInput",
    "motif-label-with-select": t === "selectInput",
    [r]: !0
  });
  return /* @__PURE__ */ d.jsx("label", { ...a, className: b, htmlFor: p, "data-motif-label": !0, children: l });
};
y.propTypes = {
  children: i.node,
  className: i.string
};
export {
  y as MotifLabel
};
